import { SecurityHelper } from '../helpers.js';

// Schema:
//   { type: 'links', items: [{ label, url }] }
export function renderLinks(block) {
  const items = Array.isArray(block.items) ? block.items : [];

  const wrapper = document.createElement('div');
  wrapper.className = 'cyx-block cyx-block-links';

  const list = document.createElement('ul');
  list.className = 'cyx-block-links-list';

  for (const item of items) {
    if (!item || typeof item !== 'object') continue;
    const safeUrl = SecurityHelper.sanitizeURL(item.url || '');
    if (!safeUrl) continue;
    const label = String(item.label || item.url || safeUrl);

    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = safeUrl;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.textContent = label;
    a.className = 'cyx-block-links-link';
    li.appendChild(a);
    list.appendChild(li);
  }

  if (!list.children.length) return null;
  wrapper.appendChild(list);
  return wrapper;
}
